import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "gridIsOpen", true);
        Vue.set(state, "protocolFormIsOpen", false);
        Vue.set(state, "protocolGridIsOpen", false);
    },
    setFormOpen(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
        state.protocolFormIsOpen = false;
        state.protocolGridIsOpen = false;
    },
    setFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
        state.protocolFormIsOpen = false;
        state.protocolGridIsOpen = false;
    },
    setProtocolFormOpen(state) {
        state.formIsOpen = false;
        state.gridIsOpen = false;
        state.protocolFormIsOpen = true;
        state.protocolGridIsOpen = false;
    },
    setProtocolFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = false;
        state.protocolFormIsOpen = false;
        state.protocolGridIsOpen = true;
    }
}
